export const QuestionProcessingStatuses = {
    READY: 'f',
    PROJECTION: 'rp',
    TRAINING: 'rt',
    POST_PROCESSING: 'pp',
    ERROR: 'exl',
    RUNNING_TRAINING: 'rt',
}

export const getQuestionProcessingStatusName = status => {
    switch (status) {
        case QuestionProcessingStatuses.READY:
            return 'Ready'
        case QuestionProcessingStatuses.PROJECTION:
            return 'Projection'
        case QuestionProcessingStatuses.TRAINING:
            return 'Training'
        case QuestionProcessingStatuses.POST_PROCESSING:
            return 'Post Processing'
        case QuestionProcessingStatuses.ERROR:
            return 'Error'
        default:
            return 'Unknown Processing Status'
    }
}
